import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import stores from '../../../stores';
import {
  Actions, BackLink, Panel, StepText, StepTitle,
} from './styles';
import { DemarcheFunnelContainer } from './DemarcheFunnelContainer';

type DemarcheFunnelLoaderProps = {
  slug: string;
  initialSituation?: string | null;
  // Carried on the query string when Stripe returns the user to the tunnel (backend-plan.md §7.2) —
  // forwarded to DemarcheFunnelContainer, which resumes the order and picks the right step.
  resumeToken?: string | null;
  paymentResult?: string | null;
};

// Owns fetching the flow's configuration from GET /api/web/v1/demarches/:slug (see
// DemarcheFunnelStore#fetchConfig) and mounts DemarcheFunnelContainer once it arrives.
// DemarcheFunnelContainer itself still takes `config` as a plain prop and is unaware of the fetch.
const DemarcheFunnelLoader: React.FC<DemarcheFunnelLoaderProps> = observer(({
  slug,
  initialSituation = null,
  resumeToken = null,
  paymentResult = null,
}) => {
  const { demarcheFunnelStore } = stores;
  const { config, isConfigLoading, configErrorStatus } = demarcheFunnelStore;

  useEffect(() => {
    demarcheFunnelStore.fetchConfig(slug);
  }, [slug]);

  if (isConfigLoading || (!config && !configErrorStatus)) {
    return (
      <Panel>
        <StepText>Chargement du formulaire…</StepText>
      </Panel>
    );
  }

  if (!config) {
    return (
      <Panel>
        <StepTitle>Le formulaire n’a pas pu se charger</StepTitle>
        <StepText>Rechargez la page pour réessayer, ou consultez le guide de cette démarche.</StepText>
        <Actions>
          <BackLink href={`/demarches-permis/${slug}`}>Consulter le guide</BackLink>
        </Actions>
      </Panel>
    );
  }

  return (
    <DemarcheFunnelContainer
      config={config}
      initialSituation={initialSituation}
      resumeToken={resumeToken}
      paymentResult={paymentResult}
    />
  );
});

export { DemarcheFunnelLoader };
